import { Injectable } from '@angular/core'
import * as Color from 'color'
import { Observable } from 'rxjs/Observable'
import { ReplaySubject } from 'rxjs/ReplaySubject'
import { Subject } from 'rxjs/Subject'
import { TipoDeConfiguracaoId } from '../../pkw-data/core/configuracao/tipo-de-configuracao-id.enum'
import { ConfiguracaoService } from './configuracao.service'
import { Layout, LAYOUT_PADRAO } from './layout'
import { LayoutPackUp } from './layout-pack-up.interface'

@Injectable()
export class LayoutService {
    aplicado: Observable<Layout>

    private _aplicado: Subject<Layout>
    private _styles: CSSStyleDeclaration

    constructor(private configuracaoService: ConfiguracaoService) {
        this._aplicado = new ReplaySubject<Layout>(1)
        this.aplicado = this._aplicado.asObservable()
        this._styles = document.body.style
    }

    obterLayoutEAplicar() {
        return this.configuracaoService
            .obter(TipoDeConfiguracaoId.LayoutPackUp)
            .map(config => {
                let layout: Layout

                if (config) {
                    layout = new Layout(config.getValor<LayoutPackUp>())
                } else {
                    layout = LAYOUT_PADRAO
                }

                if (layout.isVazio() || layout.isPadrao()) {
                    this.limpar()
                } else {
                    this.aplicar(layout)
                }

                return layout
            })
    }

    aplicar(layout: Layout) {
        const primaryColorDark = Color(layout.corPrimaria)
            .darken(0.05)
            .hex()
        const primaryColorDarker = Color(layout.corPrimaria)
            .darken(0.05)
            .hex()
        const primaryColorDarkest = Color(layout.corPrimaria)
            .darken(0.1)
            .hex()
        const primaryColorLighter = Color(layout.corPrimaria)
            .lighten(0.4)
            .hex()
        const secondaryColorDark = Color(layout.corSecundaria)
            .darken(0.1)
            .hex()
        const tertiaryColorDarker = Color(layout.corTerciaria)
            .darken(0.2)
            .hex()

        this._styles.setProperty(CSS_VARS.primaryColor, layout.corPrimaria)
        this._styles.setProperty(CSS_VARS.primaryColorDark, primaryColorDark)
        this._styles.setProperty(CSS_VARS.primaryColorDarker, primaryColorDarker)
        this._styles.setProperty(CSS_VARS.primaryColorDarkest, primaryColorDarkest)
        this._styles.setProperty(CSS_VARS.primaryColorLighter, primaryColorLighter)
        this._styles.setProperty(CSS_VARS.secondaryColor, layout.corSecundaria)
        this._styles.setProperty(CSS_VARS.secondaryColorDark, secondaryColorDark)
        this._styles.setProperty(CSS_VARS.tertiaryColor, layout.corTerciaria)
        this._styles.setProperty(CSS_VARS.navbarBgColor, layout.corPrimaria)
        this._styles.setProperty(CSS_VARS.navbarBorderColor, primaryColorDarkest)
        this._styles.setProperty(CSS_VARS.navTabsColor, layout.corTerciaria)
        this._styles.setProperty(CSS_VARS.navTabsActiveColor, tertiaryColorDarker)
        this._styles.setProperty(CSS_VARS.navbarToggleBorderColor, layout.corSecundaria)
        if (layout.possuiLogo()) {
            this._styles.setProperty(
                CSS_VARS.navbarImage,
                `url(${layout.logoNavbarHeader})`
            )
            this._styles.setProperty(CSS_VARS.navbarImageBgPosition, 'center')
            this._styles.setProperty(CSS_VARS.navbarImageBgSize, 'contain')
        }
        this._aplicado.next(layout)
    }

    limpar() {
        this._styles.removeProperty(CSS_VARS.primaryColor)
        this._styles.removeProperty(CSS_VARS.primaryColorDark)
        this._styles.removeProperty(CSS_VARS.primaryColorDarker)
        this._styles.removeProperty(CSS_VARS.primaryColorDarkest)
        this._styles.removeProperty(CSS_VARS.primaryColorLighter)
        this._styles.removeProperty(CSS_VARS.secondaryColor)
        this._styles.removeProperty(CSS_VARS.secondaryColorDark)
        this._styles.removeProperty(CSS_VARS.tertiaryColor)
        this._styles.removeProperty(CSS_VARS.navbarImage)
        this._styles.removeProperty(CSS_VARS.navbarBgColor)
        this._styles.removeProperty(CSS_VARS.navbarBorderColor)
        this._styles.removeProperty(CSS_VARS.navbarImageBgPosition)
        this._styles.removeProperty(CSS_VARS.navbarImageBgSize)
        this._styles.removeProperty(CSS_VARS.navbarToggleBorderColor)
        this._styles.removeProperty(CSS_VARS.navTabsColor)
        this._styles.removeProperty(CSS_VARS.navTabsActiveColor)
    }
}

const CSS_VARS = {
    primaryColor: '--primaryColor',
    primaryColorDark: '--primaryColorDark',
    primaryColorDarker: '--primaryColorDarker',
    primaryColorDarkest: '--primaryColorDarkest',
    primaryColorLighter: '--primaryColorLighter',
    secondaryColor: '--secondaryColor',
    secondaryColorDark: '--secondaryColorDark',
    tertiaryColor: '--tertiaryColor',
    navbarImage: '--navbar-brand-image',
    navbarBgColor: '--navbar-inverse-bg-color',
    navbarBorderColor: '--navbar-inverse-border-color',
    navbarImageBgPosition: '--navbar-brand-bg-position',
    navbarImageBgSize: '--navbar-brand-bg-size',
    navbarToggleBorderColor: '--navbar-toggle-border-color',
    navTabsColor: '--nav-tabs-color',
    navTabsActiveColor: '--nav-tabs-active-color'
}



// WEBPACK FOOTER //
// ./src/app/configuracao/shared/layout.service.ts